export default "__VITE_ASSET__CyXslVz0__"